import { IGif, IUser, IUserLink } from "services/types";

export interface ICurrentUser {
  creationtime: number;
  description: string | null;
  followers: number;
  following: number;
  gifs: number;
  links?: IUserLink[];
  name: string;
  profileImageUrl: string | null;
  profileUrl: string;
  publishedCollections: number;
  publishedGifs: number;
  preferences: string[];
  status: string;
  subscription: number;
  url: string;
  username: string;
  verified: boolean;
  views: number;
  poster: string | null;
  preview: string | null;
  thumbnail: string | null;
  email: string;
  totalGifs: number;
}

export interface IUserState {
  currentUser: ICurrentUser;
  currentUserContent: IGif[] | any [] | any;
  loadingUserContent: boolean;
  currentUserContentError: Error | null;
  currentUserFollowers: Array<IUser> | [];
  currentUserFollowersError: Error | null;
  currentUserFollows: {
    count?: number;
    cursor?: string;
    follows: Array<IUser> | [];
    status?: string;
    totalCount?: number;
    error: Error | null;
  };
  loadingUser: boolean;
  loadingUserFollows: boolean;
  userLoginError: Error | null;
  followUserError: Error | null;
  likedGifs: string[];
  loadingLikedGifs: boolean;
}

const defaultState = {
  currentUser: {} as ICurrentUser,
  currentUserContent: [],
  currentUserContentError: null,
  loadingUserContent: false,
  currentUserFollowers: [],
  currentUserFollowersError: null,
  currentUserFollows: {
    follows: [],
    error: null,
  },
  loadingUser: false,
  loadingUserFollows: false,
  userLoginError: null,
  followUserError: null,
  likedGifs: [],
  loadingLikedGifs: false,
};

export const getDefaultUserState = () => defaultState;
